import { useBankingTransactionQuery } from '@alice-financial/alice-sdk'
import { apiTxnToAppTxn } from './txnUtils'

/**
 * Thin wrapper around `useBankingTransactionQuery` that will query details of a
 * particular transaction and transform it using `apiTxnToAppTxn`
 */
export const useTransactionDetailQuery = (id: string) => {
  const { data: txnData, ...queryInfo } = useBankingTransactionQuery({ id })
  return {
    data: txnData && apiTxnToAppTxn(txnData.bankingTransaction),
    ...queryInfo,
  }
}
